<template>
  <div>
    <div class="player-connection">
      Speler:
      <div class="player-status">{{ playerConnection }}</div>
    </div>
    <div class="simulation-controls-container">
      <div class="columnControls">
        <div v-on:change="switchSimulation">
          <toggle-switch title="Brandsimulatie" icon="power-off" :state="start"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import ToggleSwitch from './subcomponents/ToggleSwitch.vue';
import * as signalR from "@microsoft/signalr";

export default {
  name: 'SimulationPanel',
  components: {
    ToggleSwitch
  },
  props: {
    displayError: null
  },
  data() {
    return {
      start: false,
      zoneSwitch: false,
      connection: null,
      defaultSettings: false,
      timer: 60,
      playerConnection: 'Offline',
      playerConnectionId: null,
      connectionId: null
    };
  },
  methods: {
    async switchSimulation() {
      this.start = !this.start;
      if (this.start) {
        if (this.playerConnection !== 'Offline') {
          await this.connection.invoke("sendMessage", "start", "");
        } else {
          this.$emit('displayError', '[ERROR] Speler is niet online.')
        }
      } else {
        await this.connection.invoke("sendMessage", "stop", "");
      }
    },
    simServiceUnavailable() {
      this.$emit('displayError', '[SERVER ERROR] Simulatie service is niet bereikbaar.')
    },
    async initGui() {
      await this.connection.invoke("sendMessage", "initGui", "");
    },
    async connect(connection) {
      let ref = this;
      try {
        await connection.start();
        await ref.initGui();
        connection.on("ReceiveMessage", function (type, message) {
          switch (type) {
            case "initGui":
              ref.playerConnectionId = message
              if (message === null) {
                ref.playerConnection = "Offline";
              } else {
                ref.playerConnection = "Online";
              }
              break;
            case "connect":
              ref.updateConnection(message);
              break;
            case "init":
              if (ref.connectionId === null) {
                ref.connectionId = message
              }
              break;
            case "disconnection":
              ref.playerConnection = "Offline";
          }
        });
      } catch (err) {
        ref.simServiceUnavailable();
      }
    },
    updateConnection(connection) {
      this.playerConnection = "Online";
      this.playerConnectionId = connection;
    },
  },
  mounted() {
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("//" + process.env.VUE_APP_API_URL_SIMULATIONSERVICE + "/simulation", {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets
        })
        .configureLogging(signalR.LogLevel.Information)
        .build();

    this.connection = connection;
    this.connect(connection);
    this.connection.hub.disconnected(function () {
      console.log('Connection disconnected')
    });
  }
}
</script>

<style scoped>
.player-status {
  color: #16cdbe;
  margin-left: 2%;
}

.player-connection {
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-right: -55px;
}

.simulation-controls-container {
  display: flex;
  flex-direction: row;
  height: 80%;
  margin-top: 15px;
  padding-right: 40px;
  padding-top: 20px;
  border-top: solid rgba(255, 255, 255, 0.2) 1px;
}
</style>